<template>
  <button class="button button--icon-only"
          :class="baseClasses"
          :disabled="disabled"
          @click="$emit('click', $event)">
    <icon v-if="icon" :icon="icon" class="button__icon" :colour="iconColour"/>
  </button>
</template>

<script>
import Icon from '../Icon'
import buttonComponentMixin from '../../mixins/buttonComponentMixin'

export default {
  name: 'IconButton',
  components: { Icon },
  mixins: [buttonComponentMixin],
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
}
</script>
